import Main from "./components/main/Main";
// import Navbar from "./components/navbar/Navbar";
import Header from "./components/header/Header";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <Header />
      <Main />
    </div>
  )
}

export default App;
